import axios from "@/api/axiosInstance";

export const exportMPDashboardCsv = async (
  intacctId: string,
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    `/api/private/stochastic/market-presence-dashboard/export/csv`,
    {
      responseType: "blob",
      headers: {
        Accept: "text/csv",
      },
      params: { intacctId },
    },
  );

  return response.data;
};